import type { Result } from '@avalara/types/index';
import type { ExistingBillingAccount, PaymentMethod } from 'types/biztech';
import conf from '../../conf';
import { receivePaymentMethods } from '../actions';
import fetch from '../fetch';

import type { Dispatch, ThunkAction } from '@avalara/types/actions';
import { isUnauthenticatedUser } from '.';
import type { UnauthenticatedUser } from '../../../../types';

export const getPaymentMethods =
  (): ThunkAction =>
  async (dispatch: Dispatch): Promise<boolean> => {
    const result: Result<Array<PaymentMethod> | UnauthenticatedUser> = await fetch(dispatch)(
      `${conf.API_URL}/api/biztech/paymentmethods`,
    );

    if (result.ok && !isUnauthenticatedUser(result.value) && Array.isArray(result.value) && result.value.length > 0) {
      dispatch(receivePaymentMethods(result.value));
      return true;
    }

    return false;
  };

export const fetchBillingAccount = (accountId: string | number) => async (dispatch: Dispatch) => {
  const response = await fetch(dispatch)(`api/v1/a/${accountId}/billingAccount`);
  if (!response.ok) throw new Error(`${response.message}`);

  const billingAccount = (await response.value) as ExistingBillingAccount;
  return billingAccount;
};
